import { cn } from '../../lib/cn';
import { withBase } from '../../lib/base';

/** Forma mínima que necesita el Avatar (compatible con Member y User). */
export interface AvatarPerson {
  first_name: string;
  last_name: string;
  avatar_path?: string | null;
}

/** Resuelve la ruta de avatar servida bajo {base}/api/uploads. */
function resolveAvatar(path: string): string {
  return withBase(path);
}

function initials(first: string, last: string): string {
  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase() || '?';
}

const sizes = {
  sm: 'h-6 w-6 text-[10px]',
  md: 'h-8 w-8 text-xs',
  lg: 'h-10 w-10 text-sm',
  xl: 'h-20 w-20 text-2xl',
} as const;

/** Avatar de una persona: foto si existe, iniciales si no. */
export function Avatar({
  member,
  size = 'sm',
  className,
}: {
  member: AvatarPerson;
  size?: keyof typeof sizes;
  className?: string;
}) {
  const label = `${member.first_name} ${member.last_name}`.trim();
  if (member.avatar_path) {
    return (
      <img
        src={resolveAvatar(member.avatar_path)}
        alt={label}
        title={label}
        className={cn('shrink-0 rounded-full object-cover', sizes[size], className)}
      />
    );
  }
  return (
    <span
      title={label}
      className={cn(
        'grid shrink-0 place-items-center rounded-full bg-brand font-mono font-semibold text-brand-ink',
        sizes[size],
        className,
      )}
    >
      {initials(member.first_name, member.last_name)}
    </span>
  );
}
